(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
  
  // Set tag colors based on content
  function setTagColors() {
    const tagElements = document.querySelectorAll('.metafield-single_line_text_field');
    tagElements.forEach(function(tagElement) {
      const textBlock = tagElement.closest('.text-block');
      if (!textBlock || textBlock.hasAttribute('data-tag-type')) return;
      
      const tagText = tagElement.textContent.trim().toLowerCase();
      let tagType = 'default';
      
      if (tagText.includes('wellness') || tagText.includes('health')) {
        tagType = 'wellness';
      } else if (tagText.includes('government')) {
        tagType = 'government';
      } else if (tagText.includes('medical') || tagText.includes('clinic')) {
        tagType = 'medical';
      } else if (tagText.includes('service')) {
        tagType = 'service';
      } else if (tagText.includes('package') || tagText.includes('plan')) {
        tagType = 'package';
      }
      
      textBlock.setAttribute('data-tag-type', tagType);
    });
  }
  
  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setTagColors);
  } else {
    setTagColors();
  }
  
  // Watch for dynamically added content
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function() {
      setTagColors();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  } catch(e) { console.error(e); }
})();
})();
